import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2, SparklesIcon, BookOpenIcon } from 'lucide-react';
import { FloatingSparkles } from './FloatingSparkles';
export function Bonus() {
  const codigosCategorias = ['Códigos para la abundancia y prosperidad financiera', 'Códigos para el amor propio y relaciones armoniosas', 'Códigos para sanación física y emocional', 'Códigos de protección energética y espiritual', 'Códigos para soltar miedos y bloqueos internos', 'Códigos para activar la intuición y claridad mental', 'Códigos para el perdón y liberación del pasado', 'Códigos para manifestar tus deseos más profundos'];
  const clubBonuses = ['La Magia de volver a Sentir (Libro Principal)', 'Ritual AM para comenzar el día con intención', 'Ritual PM para soltar y descansar', 'Rituales de Entierro para cerrar ciclos', 'Sombras y Rituales Nocturnos', 'Espacio para intenciones diarias'];
  const packLibros = ['"El Librito Azul" de Conny Méndez', '"Inteligencia Espiritual" de Dan Millman', '"Aumente su Autoestima" de Dr. Lair Ribeiro', '"Autoliberación interior" de Anthony de Mello', '"20 Increíbles Trucos Mentales" de Danilo H. Gomez'];
  return <section className="py-24 bg-burgundy text-white overflow-hidden relative" data-id="element-57">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-58">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-rosegold rounded-full blur-[100px] opacity-40 animate-pulse" data-id="element-59"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-rosegold rounded-full blur-[100px] opacity-40 animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-60"></div>
      </div>

      <FloatingSparkles count={40} color="#FFF" className="opacity-50" data-id="element-61" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-63">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-rosegold/20 rounded-full mb-6 text-rosegold" data-id="element-64">
            <Gift size={32} data-id="element-65" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif mb-4 text-[#D4849A]" data-id="element-66">
            Y además, recibes estos bonos exclusivos
          </h2>
          <p className="text-lg text-cream/80 max-w-2xl mx-auto" data-id="element-67">
            Complementa tu transformación con recursos poderosos que acelerarán
            tu proceso de cambio.
          </p>
        </motion.div>

        {/* Bonus 1 & 2 Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-68">
          {/* Bonus 1: 100 Códigos Sagrados */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="shimmer-border bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10 flex flex-col items-center text-center relative z-10" data-id="element-69">
            <span className="inline-block bg-rosegold/20 text-rosegold text-sm font-semibold uppercase tracking-wider px-4 py-1.5 rounded-full mb-6" data-id="element-70">
              Bonus 1
            </span>
            <div className="w-full max-w-[280px] mb-8" data-id="element-71">
              <img src="https://cdn.magicpatterns.com/uploads/8Ap975UsEthxuUgH7a88o5/Libro_100_Codigos_Sagrados_promocional.png" alt="100 Códigos Sagrados" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-72" />
            </div>
            <h3 className="text-2xl font-serif text-rosegold mb-3" data-id="element-73">
              100 Códigos Sagrados
            </h3>
            <p className="text-cream/80 leading-relaxed mb-4" data-id="element-74">
              Una guía poderosa con 100 códigos sagrados canalizados para
              activar frecuencias de transformación en todas las áreas de tu
              vida. Cada código viene con su intención específica y las
              instrucciones para activarlo correctamente.
            </p>

            <div className="flex items-center gap-2 mb-5" data-id="element-75">
              <BookOpenIcon className="text-rosegold" size={18} data-id="element-76" />
              <span className="text-rosegold font-medium text-sm uppercase tracking-wider" data-id="element-77">
                Incluye códigos para:
              </span>
            </div>

            <ul className="space-y-3 text-left w-full" data-id="element-78">
              {codigosCategorias.map((categoria, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.5 + index * 0.1
            }} className="flex items-start" data-id="element-79">
                  <SparklesIcon className="text-rosegold mt-1 mr-3 flex-shrink-0" size={16} data-id="element-80" />
                  <span className="text-cream text-sm" data-id="element-81">{categoria}</span>
                </motion.li>)}
            </ul>

            <p className="text-cream/70 text-sm italic mt-6" data-id="element-82">
              Solo repite el código 45 veces con fe e intención, y deja que la
              energía sagrada trabaje en tu vida.
            </p>
          </motion.div>

          {/* Bonus 2: Pack de Libros */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="shimmer-border bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10 flex flex-col items-center text-center relative z-10" data-id="element-83">
            <span className="inline-block bg-rosegold/20 text-rosegold text-sm font-semibold uppercase tracking-wider px-4 py-1.5 rounded-full mb-6" data-id="element-84">
              Bonus 2
            </span>
            <div className="w-full max-w-[320px] mb-8" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/cDeTBGZaSkoEURaufKvn9a/Pack_de_libros_de_transformacion_espiritual.png" alt="Pack de Libros de Transformación Espiritual" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-86" />
            </div>
            <h3 className="text-2xl font-serif text-rosegold mb-3" data-id="element-87">
              Pack de Libros
            </h3>
            <p className="text-cream/80 leading-relaxed mb-6" data-id="element-88">
              Un conjunto esencial para transformar mente y espíritu.
            </p>
            <ul className="space-y-3 text-left w-full" data-id="element-89">
              {packLibros.map((libro, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.5 + index * 0.1
            }} className="flex items-start" data-id="element-90">
                  <SparklesIcon className="text-rosegold mt-1 mr-3 flex-shrink-0" size={16} data-id="element-91" />
                  <span className="text-cream text-sm" data-id="element-92">{libro}</span>
                </motion.li>)}
            </ul>
            <p className="text-cream/70 text-sm italic mt-6" data-id="element-93">
              Una selección poderosa para mujeres que quieren vivir con más
              propósito, paz y claridad interna.
            </p>
          </motion.div>
        </div>

        {/* Bonus 3: The Club */}
        <div className="shimmer-border flex flex-col lg:flex-row items-center gap-12 lg:gap-20 bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10 relative z-10" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-95">
            <img src="https://cdn.magicpatterns.com/uploads/3hdKkkLx1sKwWpCcGoZXUm/La_magia_de_volver_a_sentir.png" alt="The Club Bonus" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-96" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-97">
            <span className="inline-block bg-rosegold/20 text-rosegold text-sm font-semibold uppercase tracking-wider px-4 py-1.5 rounded-full mb-6" data-id="element-98">
              Bonus 3
            </span>
            <h3 className="text-3xl font-serif text-rosegold mb-2" data-id="element-99">The Club</h3>
            <p className="text-xl font-serif italic text-cream/90 mb-8" data-id="element-100">
              Suplementario de Mujeres
            </p>

            <p className="text-cream/80 mb-8 leading-relaxed" data-id="element-101">
              Una colección exclusiva de guías y rituales diseñados para
              acompañarte en tu día a día. Porque la verdadera transformación
              requiere de prácticas sostenibles.
            </p>

            <ul className="space-y-4" data-id="element-102">
              {clubBonuses.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.4 + index * 0.1
            }} className="flex items-start" data-id="element-103">
                  <CheckCircle2 className="text-rosegold mt-1 mr-3 flex-shrink-0" size={20} data-id="element-104" />
                  <span className="text-cream" data-id="element-105">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}